import React, { FC, ReactNode } from 'react';
import { StyledDesktopMenu } from './AllieDesktopMenu.styles';

export interface DesktopMenuProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  expanded?: boolean;
  menuRef?: React.RefObject<HTMLDivElement>;
  'data-testid'?: string;
}

/**
 * AllieDesktopMenu - Desktop menu component with styled components
 * Maintains the original styling and behavior from the removed Menu.styles.ts
 */
export const AllieDesktopMenu: FC<DesktopMenuProps> = ({
  children,
  className,
  onClick,
  expanded = false,
  menuRef,
  'data-testid': dataTestId,
}) => {
  return (
    <StyledDesktopMenu
      className={`menu-desktop ${expanded ? 'expanded' : ''} ${className || ''}`}
      onClick={onClick}
      ref={menuRef}
      data-testid={dataTestId}
    >
      {children}
    </StyledDesktopMenu>
  );
};

AllieDesktopMenu.displayName = 'AllieDesktopMenu';
